import moment from 'moment';

export type Weekday = 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday';

const HEBREW_WEEKDAYS: Record<Weekday, string> = {
  sunday: 'ראשון',
  monday: 'שני',
  tuesday: 'שלישי',
  wednesday: 'רביעי',
  thursday: 'חמישי',
  friday: 'שישי',
  saturday: 'שבת',
};

export const getDayName = (englishDayName: string, language: 'en' | 'he'): string => {
  if (language === 'en') return englishDayName;
  return HEBREW_WEEKDAYS[englishDayName as Weekday] ?? englishDayName;
};

export const formatSecondsToTime = (secondsSinceMidnight: number, timeFormat: string): string =>
  moment.unix(secondsSinceMidnight).tz('utc').format(timeFormat);
